import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import * as yup from "yup";
import { SupplierListResponse } from "../Supplier/Supplier.constants";

export type Personel = {
  id: string;
  email: string;
  password?: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
};

export interface StaffListResponse extends Array<Personel> {}

export interface DeviceModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Personel;
  devicePartListMutation?: UseMutateFunction<
    DevicePartListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
  deviceListMutation?: UseMutateFunction<
    StaffListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface DeviceDetailModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: any;
}

export interface DeviceBuySellModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalData?: { id?: string | undefined; modalType?: string | undefined };
  deviceListMutation: UseMutateFunction<
    StaffListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface DevicePartBuySellModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalData?: { id?: string | undefined; modalType?: string | undefined };
  supplierData: SupplierListResponse | undefined;
  devicePartListMutation: UseMutateFunction<
    DevicePartListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface DevicePartModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  devicePartData?: any;
  supplierData: SupplierListResponse | undefined;
  devicePartListMutation: UseMutateFunction<
    DevicePartListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

export interface DeviceModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  deviceData?: any;
}

export interface DeviceAddRequest {
  name: string;
  description: string;
  warranty_period: number;
  system: number;
  device_part: Array<string>;
}

export interface DeviceAddResponse {
  id: number;
  name: string;
  description: string;
  warranty_period: number;
  system: number;
  device_part: Array<string>;
  status: number;
}

export interface DeviceUpdateRequest {
  id: number;
  name: string;
  description: string;
  warranty_period: number;
  system: number;
  device_part: Array<string>;
}

export interface DeviceUpdateResponse {
  status: number;
}

export interface StaffDeleteRequest {
  id: string;
}

export interface StaffDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface DeviceBuySellRequest {
  device: string;
  amount: number;
  total_price: number;
  content_type: number;
  payment_type: number;
  note: string;
  date: Date;
  supplier: string;
}

export interface DevicePartBuySellRequest {
  device_part: string;
  amount: number;
  total_price: number;
  content_type: number;
  payment_type: number;
  note: string;
  date: Date;
  supplier: string;
}

export interface DeviceBuySellResponse {
  device: number;
  amount: number;
  total_price: number;
  content_type: number;
  payment_type: number;
  note: string;
  date: string;
  status: number;
}

export const payOptions = [
  { key: "Nakit", value: 1 },
  { key: "Transfer", value: 2 },
  { key: "Kredi Kartı", value: 3 },
  { key: "Çek", value: 4 },
  { key: "Bilinmiyor", value: 5 },
];

export interface DevicePartListResponse
  extends Array<{ id: string; description: string; name: string }> {}

export const deviceAddSchema = yup.object().shape({
  name: yup.string().required("Cihaz adı boş bırakılamaz"),
  warranty_period: yup
    .number()
    .required("Garanti süresi boş bırakılamaz")
    .min(0, "Garanti süresi 0'dan küçük olamaz"),
});

export const deviceUpdateSchema = yup.object().shape({
  name: yup.string().required("Cihaz adı boş bırakılamaz"),
  warranty_period: yup
    .number()
    .required("Garanti süresi boş bırakılamaz")
    .min(0, "Garanti süresi 0'dan küçük olamaz"),
});

export const deviceBuySellSchema = yup.object().shape({
  amount: yup.string().required("Miktar adı boş bırakılamaz"),
  // total_price: yup.string().required("Toplam fiyat boş bırakılamaz"),
});
